// NewsTalk (c) Copyright 2023 by Qwixotic
// 
// File:   NewsTalkHome.js
// Author: Percipient Reverence
// Date:   6-May-2023
//
// Description:
//
//   This is the home page for NewsTalk.  It describes the site and lists the available media
//   outlets.

import React, {useState, useEffect} from 'react'
import { DataGrid, GridRowsProp, GridColDef } from '@mui/x-data-grid';

// Local imports
import { myFetch } from './lib/Util'
import { Link, MediaOutletImageLink } from './lib/Components'

export const NewsTalkHomeEP = () => {
  let [MediaOutlets, MediaOutletsSet] = useState([])

  // Fetch the information for all available media outlets.
  useEffect(() => {
    myFetch('/nt/MediaOutlets/')
      .then(res => res.json())
      .then(MediaOutletsSet)
  }, [])

  if (MediaOutlets.length === 0) {
    return (
      <div>
        Newstalk home page loading...
      </div>
    )
  }

  let Rows: GridRowsProp = MediaOutlets.map((MediaOutlet) => {return (
    {id:            MediaOutlet.MOID,
     DisplayOrder:  MediaOutlet.DisplayOrder,
     MediaOutlets:  {Name: MediaOutlet.Name,  MOID: MediaOutlet.MOID},
     SectionCount:  MediaOutlet.SectionCount,
     Logo:          {URL: MediaOutlet.URL, ImageName: MediaOutlet.ImageName}
    })})

  // The column's hide property is became deprecated and then discontinued.  Now instead use the
  // columnVisibilityModel property with <DataGrid>.
  const Columns: GridColDef[] = [
    {field: 'id'           },
    {field: 'DisplayOrder' },
    {field: 'MediaOutlets', headerName: 'Media Outlets', flex: 25,
     renderCell: (params) => (<Link href={'/MediaOutlet/' + params.value.id} fontSize='1.2rem' sx={{margin: '10px 0px 10px 0px'}}>
                                {params.value.Name}
                              </Link>)},
    {field: 'SectionCount', headerName: 'Number Sections', flex: 25, align: 'center'},
    {field: 'Logo', headerName: 'Logo', flex: 50,
     renderCell: (params) => (<MediaOutletImageLink MediaOutlet={params.value} margin={{'margin': '10px 0px 10px 0px'}}/>)}
  ]
  
  return (
    <>
      <DataGrid rows={Rows} columns={Columns} autoHeight={true} hideFooter={true}
                sx={{margin: '0px 20px 0px 20px'}}
                getRowHeight={() => {return 'auto'}}
                columnVisibilityModel={{id: false, DisplayOrder: false, SID: false}}/>
    </>
  )

}
